import { DataTablePFSEvent } from 'primereact/datatable'

import { FormikValues } from 'formik'
import { PROJECT_TYPES_IDS } from 'src/utils/constants'
import { customISOString } from 'src/utils/dateUtils'

function toValueStringArray(item: []) {
	return item?.map((c) => c.value)
}

type Permissions = {
	corporate: boolean
	ftth: boolean
}

export class IncidentExportRequest {
	user: string | undefined
	language: string
	countryId: string
	corporateGroupId: string[]
	customersId: string[]
	dateFrom: string | undefined
	dateTo: string | undefined
	sortField: string | undefined
	sortOrder: number | undefined
	searchKeyword: string | undefined
	projectTypesId: string[] | undefined
	reportTypesId: string[] | undefined
	reportOriginsId: string[] | undefined
	affectationTypesId: string[] | undefined
	degradationTypesId: string[] | undefined
	serviceTypesId: string[] | undefined
	incidentStatuesId: string[] | undefined
	rfoSentStatuses: string[] | undefined

	constructor(
		user: string | undefined,
		language: string,
		countryId: string,
		corporateGroupId: [],
		customersId: [],
		dateFrom: Date | undefined,
		dateTo: Date | undefined,
		sortField: string | undefined,
		sortOrder: number | undefined,
		searchKeyword: string | undefined,
		projectTypesId: string[] | undefined,
		reportTypesId: string[] | undefined,
		reportOriginsId: string[] | undefined,
		affectationTypesId: string[] | undefined,
		degradationTypesId: string[] | undefined,
		serviceTypesId: string[] | undefined,
		incidentStatuesId: string[] | undefined,
		rfoSentStatuses: string[] | undefined
	) {
		this.user = user
		this.language = language
		this.countryId = countryId
		this.corporateGroupId = toValueStringArray(corporateGroupId)
		this.customersId = toValueStringArray(customersId)
		this.dateFrom = customISOString(dateFrom)
		this.dateTo = customISOString(dateTo)
		this.sortField = sortField
		this.sortOrder = sortOrder
		this.searchKeyword = searchKeyword
		this.projectTypesId = projectTypesId
		this.reportTypesId = reportTypesId
		this.reportOriginsId = reportOriginsId
		this.affectationTypesId = affectationTypesId
		this.degradationTypesId = degradationTypesId
		this.serviceTypesId = serviceTypesId
		this.incidentStatuesId = incidentStatuesId
		this.rfoSentStatuses = rfoSentStatuses
	}

	static fromValues(
		isInternal: boolean,
		user: string | undefined,
		language: string,
		filter: FormikValues,
		tablePFSEvent: DataTablePFSEvent | undefined,
		permissions: Permissions
	) {
		const sortOptions = {
			sortField: tablePFSEvent?.sortField || '',
			sortOrder: tablePFSEvent?.sortOrder || 0,
			multiSortMeta: tablePFSEvent?.multiSortMeta || [],
		}
		const tableFilter = {
			...(tablePFSEvent?.filters || {}),
		}

		let projectTypesId = tableFilter.projectTypesId?.value

		if (permissions.ftth && !permissions.corporate) {
			projectTypesId = [PROJECT_TYPES_IDS.FTTH]
		} else if (!permissions.ftth && permissions.corporate) {
			projectTypesId = [PROJECT_TYPES_IDS.CORPORATE]
		}

		return new IncidentExportRequest(
			isInternal ? undefined : user,
			language,
			filter.countryId?.value,
			filter.corporateGroupId,
			filter.customersId,
			filter.dateFrom,
			filter.dateTo,
			sortOptions.sortField || 'createdDate',
			sortOptions.sortOrder || -1,
			tableFilter.global?.value,
			projectTypesId,
			tableFilter.reportTypesId?.value,
			tableFilter.reportOriginsId?.value,
			tableFilter.affectationTypesId?.value,
			tableFilter.degradationTypesId?.value,
			tableFilter.serviceTypesId?.value,
			tableFilter.incidentStatuesId?.value,
			tableFilter.rfoSentStatuses?.value
		)
	}
}
